var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.679 12V3.973H.188V12zm-1.26-9.1c.804 0 1.447-.672 1.447-1.477C2.866.644 2.223 0 1.42 0A1.43 1.43 0 0 0 0 1.423c0 .805.643 1.476 1.42 1.476M12 12V7.597c0-2.147-.482-3.812-3-3.812-1.205 0-2.009.671-2.357 1.289h-.027v-1.1H4.232V12h2.491V8.027c0-1.047.188-2.04 1.473-2.04s1.313 1.18 1.313 2.12V12z"
  })));
};
export default SvgLinkedin;